import { useState } from 'react';
import { analyticsEventSend } from 'src/utils/analytics/analyticsEventSend';

export const filterByDateOptions = ['In', 'In or after', 'In or before'];

export const useRequestFilters = (selectedYear: number) => {
  const initialDate = new Date(selectedYear, 0, 1);
  const [vacationType, setVacationType] = useState<Array<string>>([]);
  const [vacationStatus, setVacationStatus] = useState<Array<string>>([]);
  const [filterDateType, setFilterDateType] = useState('In');
  const [filterDate, setFilterDate] = useState<Date | 'Full Year'>('Full Year');
  const [filterDirection, setFIlterDirection] = useState('desc');
  const [sortBy, setSortBy] = useState('startDate');

  const filterDirectionHandler = (value: string) => {
    setFIlterDirection(value);
    analyticsEventSend('Direction Filter Changes');
  };

  const filterDirectionResetHandler = () => {
    setFIlterDirection('desc');
  };

  const vacationTypeHandler = (value) => {
    analyticsEventSend('Vacation filtered by type');
    if (value === 'All') {
      setVacationType([]);
      return;
    }
    if (vacationType.includes(value)) {
      setVacationType((prev) => prev.filter((item) => item !== value));
      return;
    } else {
      setVacationType((prev) => [...prev, value]);
    }
  };

  const vacationStatusHandler = (value) => {
    analyticsEventSend('Vacation filtered by status');
    if (value === 'All') {
      setVacationStatus([]);
      return;
    }
    if (vacationStatus.includes(value)) {
      setVacationStatus((prev) => prev.filter((item) => item !== value));
      return;
    } else {
      setVacationStatus((prev) => [...prev, value]);
    }
  };

  const filterDateHandler = (value, type) => {
    analyticsEventSend('Vacation filtered by month');
    setFilterDateType(value);
    if (type) {
      setSortBy(type);
    }
  };

  const filterDateYearAndMonthHandler = (value, sort?) => {
    if (value === 'Full Year') {
      setFilterDate(value);
      return;
    }
    setSortBy(sort);
    setFilterDate(new Date(selectedYear, +value, 1));
    analyticsEventSend('Vacation filtered by month');
  };

  const clearVacationStatusHandler = () => {
    setVacationStatus([]);
  };

  const clearFilterDateHandler = () => {
    setFilterDateType('In');
    setFilterDate('Full Year');
    setSortBy('startDate');
  };

  const clearVacationTypeHandler = () => {
    setVacationType([]);
  };

  return {
    filterDirection,
    vacationType,
    vacationStatus,
    filterDateType,
    filterDate,
    vacationTypeHandler,
    vacationStatusHandler,
    filterDateHandler,
    clearVacationStatusHandler,
    clearFilterDateHandler,
    clearVacationTypeHandler,
    filterDateYearAndMonthHandler,
    filterDirectionHandler,
    filterDirectionResetHandler,
    initialDate,
    sortBy,
  };
};
